import { catchAll } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MY_CLUB_SLUG_CARDS,
  ANY_SPORT_PLAYERS_SLUG,
  ANY_SPORT_SCOUTING_CENTER_STATS,
  ANY_SPORT_SCOUTING_CENTER_WATCHLISTS,
  MLB_CARDS_SLUG,
  MLB_MARKET,
  MLB_MY_CLUB_SLUG,
  MLB_TEAMS_SLUG,
} from '@sorare/core/src/constants/__generated__/routes';

import { MarketSubscriptions } from '@sorare/marketplace/src/components/MarketSubscriptions';

const AUCTION_SUBSCRIPTION_ROUTES = [
  MLB_CARDS_SLUG,
  catchAll(MLB_MARKET),
  catchAll(MLB_MY_CLUB_SLUG),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(MLB_TEAMS_SLUG),
  catchAll(ANY_SPORT_SCOUTING_CENTER_STATS),
  catchAll(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS),
];

const OFFERS_SUBSCRIPTION_ROUTES = [
  MLB_CARDS_SLUG,
  catchAll(MLB_MARKET),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(MLB_TEAMS_SLUG),
  catchAll(ANY_SPORT_SCOUTING_CENTER_STATS),
  catchAll(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS),
  ANY_SPORT_MY_CLUB_SLUG_CARDS,
];

const PRIMARY_OFFERS_SUBSCRIPTION_ROUTES = [
  MLB_CARDS_SLUG,
  catchAll(MLB_MARKET),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(ANY_SPORT_SCOUTING_CENTER_STATS),
  catchAll(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS),
];

export const MLBMarketSubscriptions = () => {
  return (
    <MarketSubscriptions
      sports={[Sport.BASEBALL]}
      auctionsRoutes={AUCTION_SUBSCRIPTION_ROUTES}
      offersRoutes={OFFERS_SUBSCRIPTION_ROUTES}
      primaryOffersRoutes={PRIMARY_OFFERS_SUBSCRIPTION_ROUTES}
    />
  );
};
